import { useLazyQuery } from "@apollo/client";
import { useAppDispatch } from "../../../redux/hook";
import { bankingClient } from "../../../apolloClient";
import { useEffect } from "react";
import { _myInformation, MyInformationItem } from "../../../indexDB/data";
import { ALL_ACCOUNT } from "../../../graphql/graphql_banking/legder/query";
import { setAllAccount } from "../../../redux/ledger/ledgerSlice";
import { AllAccount } from "../../../graphql/graphql_banking/legder/types/AllAccount";
import { AccountBankingInfo } from "../../../graphql/graphql_banking/legder/types/AccountBankingInfo";

const useAllAccount = (synchronize?: boolean) => {
  const dispatch = useAppDispatch();

  const [getAll, { loading, data }] = useLazyQuery<AllAccount>(ALL_ACCOUNT, {
    fetchPolicy: "no-cache",
    client: bankingClient,
    async onCompleted(data) {
      if (data?.allAccount) {
        await _myInformation.setItem(
          MyInformationItem.ALL_LEDGERS,
          data.allAccount,
        );
        await setData(data.allAccount);
      }
    },
  });

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const cache = await _myInformation.getItem(MyInformationItem.ALL_LEDGERS);
    if (cache && !synchronize) {
      setData(cache as AccountBankingInfo[]);
      return;
    }
    getAll();
  };

  const setData = async (data: (AccountBankingInfo | null)[]) => {
    dispatch(setAllAccount(data));
  };

  return { getAll, loading, data };
};

export default useAllAccount;
